import React from 'react';
import { Box, Skeleton } from '@mui/material';

const WindmillFlowSidebarSkeleton: React.FC = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Jobs List Skeleton */}
      <Box sx={{ p: 2, flex: 1, overflowY: 'auto' }}>
        {/* Multiple Job Card Skeletons */}
        {[1, 2, 3, 4, 5].map(index => (
          <Box
            key={index}
            sx={{
              mb: 2,
              p: 2,
              border: '1px solid #E0E0E0',
              borderRadius: 2,
              backgroundColor: 'transparent',
            }}
          >
            {/* Status and Duration Row */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: 1,
              }}
            >
              {/* Status Skeleton */}
              <Skeleton
                variant="text"
                width={60}
                height={20}
                sx={{ fontWeight: 600 }}
              />

              {/* Duration with Clock Icon Skeleton */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Skeleton variant="circular" width={12} height={12} />
                <Skeleton variant="text" width={40} height={16} />
              </Box>
            </Box>

            {/* Job ID Skeleton */}
            <Skeleton
              variant="rectangular"
              width="100%"
              height={24}
              sx={{
                borderRadius: '4px',
                marginBottom: '8px',
              }}
            />

            {/* Creation Date Skeleton */}
            <Skeleton variant="text" width={140} height={16} sx={{ mt: 0.5 }} />

            {/* Args Section Skeleton */}
            <Box sx={{ mt: 1 }}>
              <Skeleton
                variant="text"
                width={30}
                height={12}
                sx={{ mb: 0.5 }}
              />
              {/* Multiple arg lines */}
              {[1, 2].map(argIndex => (
                <Skeleton
                  key={argIndex}
                  variant="text"
                  width={`${60 + argIndex * 20}%`}
                  height={12}
                  sx={{ mb: 0.25 }}
                />
              ))}
            </Box>
          </Box>
        ))}

        {/* Pagination Controls Skeleton */}
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          mt={2}
          gap={1}
        >
          <Skeleton variant="circular" width={32} height={32} />
          <Skeleton variant="text" width={80} height={16} />
          <Skeleton variant="circular" width={32} height={32} />
        </Box>
      </Box>
    </Box>
  );
};

export default WindmillFlowSidebarSkeleton;
